export interface StepSection {
  step: string;
  title: string;
  subtitle?: string;
  description?: string;
}
